import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-preventing-fraud-modal',
  templateUrl: './preventing-fraud-modal.component.html',
  styleUrls: ['./preventing-fraud-modal.component.scss'],
})
export class PreventingFraudModalComponent implements OnInit, OnDestroy {
  count = 10;
  timer: any;
  constructor(private modalRef: MatDialogRef<PreventingFraudModalComponent>) {}

  close() {
    if (this.count !== 0) {
      return;
    }
    this.modalRef.close(true);
  }

  ngOnInit(): void {
    this.startCountdown();
  }

  ngOnDestroy(): void {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  startCountdown(): void {
    this.timer = setInterval(() => {
      this.count--;
      if (this.count <= 0) {
        clearInterval(this.timer);
      }
    }, 1000);
  }
}
